<template>
  <modal v-model="model" max-width="600" persistent>
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <p>
        Select an option for handling references that have been voted
        upon:
      </p>
      <option-list v-model="selectedOption">
        <option-list-item
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.title }}
          <template #caption>{{ option.text }}</template>
        </option-list-item>
      </option-list>
    </template>
    <template #actions>
      <action-button class="mr-2" @click="$emit('input', false)">
        Cancel
      </action-button>
      <action-button
        color="primary"
        @click="$emit('confirm', selectedOption)"
      >
        Confirm
      </action-button>
    </template>
  </modal>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import Modal from '@/components/Common/Modal';
import OptionList from '@/components/Common/OptionList';
import OptionListItem from '@/components/Common/OptionListItem';
import { VotesRequiredUpdateStrategy } from '@/enums';

const MANY_TO_ONE_CHANGE_STRATEGIES = [
  VotesRequiredUpdateStrategy.SCREEN_FROM_SINGLE_VOTE,
  VotesRequiredUpdateStrategy.REQUIRE_CONFIRMING_VOTE,
];

const ONE_TO_MANY_CHANGE_STRATEGIES = [
  VotesRequiredUpdateStrategy.KEEP_SINGLE_VOTE_OUTCOMES,
  VotesRequiredUpdateStrategy.REMOVE_SINGLE_VOTE_OUTCOMES,
];

const OPTION_TO_PROPS = {
  [VotesRequiredUpdateStrategy.KEEP_SINGLE_VOTE_OUTCOMES]: {
    title: 'Preserve existing screened references',
    text:
      'Keep included references screened via a single reviewer vote.',
  },
  [VotesRequiredUpdateStrategy.REMOVE_SINGLE_VOTE_OUTCOMES]: {
    title: 'Require additional review vote',
    text:
      'Existing references screened via a single reviewer will require an additional reviewer vote.',
  },
  [VotesRequiredUpdateStrategy.SCREEN_FROM_SINGLE_VOTE]: {
    title: 'Screen based on single vote',
    text:
      'References with a single vote will be considered screened based on the existing reviewer vote.',
  },
  [VotesRequiredUpdateStrategy.REQUIRE_CONFIRMING_VOTE]: {
    title: 'Require additional reviewer vote',
    text:
      'References with a single vote will be considered partially screened and require a vote to confirm.',
  },
};

const ONE_TO_MANY_TITLE = 'Require two reviewer votes to screen';
const MANY_TO_ONE_TITLE = 'Require one reviewer vote to screen';

export default {
  name: 'RequiredVoteChangeModal',
  components: { ActionButton, Modal, OptionList, OptionListItem },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    changeToMany: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      selectedOption: this.changeToMany
        ? ONE_TO_MANY_CHANGE_STRATEGIES[0]
        : MANY_TO_ONE_CHANGE_STRATEGIES[0],
    };
  },
  computed: {
    model: {
      set: function (value) {
        this.$emit('input', value);
      },
      get: function () {
        return this.value;
      },
    },
    title() {
      return this.changeToMany
        ? ONE_TO_MANY_TITLE
        : MANY_TO_ONE_TITLE;
    },
    strategies() {
      return this.changeToMany
        ? ONE_TO_MANY_CHANGE_STRATEGIES
        : MANY_TO_ONE_CHANGE_STRATEGIES;
    },
    options() {
      return this.strategies.map((option) => ({
        ...OPTION_TO_PROPS[option],
        value: option,
      }));
    },
  },
};
</script>
